
import {
  GET_RAFFLE_PRODUCTS,
  AUTH_TOKEN_KEY,
  POST_RAFFLE_PRODUCTS
} from '../constants';

import fetch from '../utils/Api';

export const getRaffleProducts =  () => ({
  type: GET_RAFFLE_PRODUCTS,
  payload:fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  }).get('/raffles/1')
  .then(response => response.data)
})

export const submitRaffle = payload => ({
  type: POST_RAFFLE_PRODUCTS,
  payload:fetch({
    Authorization: 'Bearer '+localStorage.getItem(AUTH_TOKEN_KEY)
  }).post('/raffles', payload).then(res=>res.data)
})
